import { AutogenLayoutHoursOfService } from "./autogen/AutogenLayoutHoursOfService";
import { DataSourceExecutionEvent, MultiButton } from "@mcleod/components";
import { CommonTooltips } from "@mcleod/common";
import {PlanningUtil} from "../planning/PlanningUtil";

export class HoursOfService extends AutogenLayoutHoursOfService {
    public saveButton:MultiButton;

    onLoad(): void | Promise<void> {
        this.layoutHoursOfServiceTable.tableDriverHours.addContentsChangedListener(() => {
            this.updateRemainingHours();
        });
    }

    sourceDriverInfoAfterExecution(event: DataSourceExecutionEvent) {
        const isUSA = "C" !== this.sourceDriverInfo.activeRow?.get("country_hos_rules");
        const numDays = isUSA ? "8" : "30";
        this.layoutHoursOfServiceTable.isCanadianHOS = !isUSA;
        this.labelLastNDays.text = `Last ${numDays} Days`
        CommonTooltips.setTooltipContentLayout(this.textboxName, this.sourceDriverInfo.activeRow.get("id"), "lme/dispatch/asset/DriverQuickInfo", {
            minWidth: 128,
            minHeight: 140
        })
        this.setLabelVisibility();
    }

    updateRemainingHours() {
        this.textboxAvlHoursToday.text = PlanningUtil.convertToHours(this.layoutHoursOfServiceTable.getRemainingHours(0).toFixed(2));
        this.textboxAvlHoursTomorrow.text = PlanningUtil.convertToHours(this.layoutHoursOfServiceTable.getRemainingHours(1).toFixed(2));
    }

    setLabelVisibility() {
        const showLabels = this.sourceDriverInfo.summaryData?.getBoolean("show_mc_fields", false);
        this.textboxDutyStatus.visible = showLabels;
        this.textboxAvlDriveHours.visible = showLabels;
        this.textboxAvlOndutyHours.visible = showLabels;
        this.textboxLastUpdate.visible = showLabels;
    }
}
